module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAWCAQAAABeMbWRAAAAeklEQVQoz2MwDTNe6sDCgAGY/vkzRH3GIsXCG/+ZhSHsM4ND9IE/aHIOLMYrjf8br8Ri4EBJMaJLfV7KEMawijeaGVXiwT/1Db+MGAJ/KzGhG/ddjcGM4RfjKjRhcy3jl8Y/TX0HubCJH0b4GO/DKszAYCVm4opFmAEA2EBHMZt/ptIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./images/login&reg&mine/goshare.png
// module id = 305
// module chunks = 0